export default "__VITE_ASSET__BnqDXwSv__"